import { PreIPODealsReducerStateType } from '@modules/pre-ipo-deals/pre-ipo-deals-section/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'startDate',
  clearPage: true,
  totalCount: 0
} as PreIPODealsReducerStateType;

export const preIPODealsLiveListStateReducerSlice = createSlice({
  name: 'preIPODealsLiveListStateReducer',
  initialState,
  reducers: {
    resetPreIPODealsLiveListStateReducerValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'startDate',
      totalCount: 0
    }),
    updatePreIPODealsLiveListStateReducerValues: (state, { payload }) => ({
      ...state,
      ...payload
    })
  }
});

export const {
  resetPreIPODealsLiveListStateReducerValues,
  updatePreIPODealsLiveListStateReducerValues
} = preIPODealsLiveListStateReducerSlice.actions;

export default preIPODealsLiveListStateReducerSlice.reducer;
